import { render, staticRenderFns } from "./PhotoViewer.vue?vue&type=template&id=06731954&"
import script from "./PhotoViewer.vue?vue&type=script&lang=js&"
export * from "./PhotoViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports